import { useT } from "~/i18n";
import { TerritoryLoadingMap } from "./territory-loading-map";

/** The approved Território composition, independent of session and timer state. */
export function TerritoryLoadingScreen({
  label,
  delayed,
  retryVisible,
  onRetry,
  onSignOut,
}: {
  label: string;
  delayed: boolean;
  retryVisible: boolean;
  onRetry: () => void;
  onSignOut?: () => void;
}) {
  const t = useT();
  return (
    <div className="territory-loading">
      <a className="skip-link" href="#loading-main">
        {t("a11y.skipToContent")}
      </a>
      <header className="territory-loading__header">
        <img src="/taxchannel-wordmark.svg" alt={t("app.brand")} width="190" height="39" />
        <span className="territory-loading__product">{t("app.name")}</span>
      </header>
      <main id="loading-main" className="territory-loading__main" tabIndex={-1}>
        <div className="territory-loading__intro">
          <h1>{t("auth.loading.title")}</h1>
          <p className="territory-loading__description">{t("auth.loading.description")}</p>
          <div className="territory-loading__status-row">
            <span className="territory-loading__spinner" aria-hidden="true" />
            <div>
              {/* The live region is not aria-busy: delayed copy must be announced. */}
              <output aria-live="polite" aria-atomic="true" aria-label={label}>
                <strong>{delayed ? t("auth.loading.delayed") : label}</strong>
                <span>{t(delayed ? "auth.loading.delayedDetail" : "auth.loading.workspace")}</span>
              </output>
              {delayed && onSignOut && (
                <button type="button" className="btn territory-loading__retry" onClick={onSignOut}>
                  {t("auth.signOut")}
                </button>
              )}
              {retryVisible && (
                <button
                  type="button"
                  className="btn btn--primary territory-loading__retry"
                  aria-disabled={!delayed}
                  onClick={() => {
                    if (delayed) onRetry();
                  }}
                >
                  {t("common.retry")}
                </button>
              )}
            </div>
          </div>
        </div>
        <div className="territory-loading__figure" aria-hidden="true">
          <TerritoryLoadingMap />
          <span className="territory-loading__map-label">{t("auth.loading.territory")}</span>
        </div>
      </main>
      <footer className="territory-loading__footer">
        <span>
          {t("app.brand")} · {t("app.name")}
        </span>
        <span>{t("auth.loading.country")}</span>
      </footer>
    </div>
  );
}
